module.exports = __webpack_public_path__ + "img/tg.9817ed05.png";